import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const temperatureListingMap = new Map();

temperatureListingMap.set(KnowEdmTableData.DepthMD, {
  key: KnowEdmTableData.DepthMD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'Depth MD',
});

temperatureListingMap.set(KnowEdmTableData.Temperature, {
  key: KnowEdmTableData.Temperature,
  unit: defaultUnits.get(QuantitiesTypes.Temperature),
  quantity: QuantitiesTypes.Temperature,
  label: 'Temperature',
});

export { temperatureListingMap };